import React from "react";
import "./App.css";
import logo from "./assets/logo.png";
import accHero from "./assets/acc-hero.png";
import heroLogo from "./assets/Web-hero.png";

const steamUrl =
  "https://store.steampowered.com/app/3976490/A_Christmas_Carol_But_With_Anime_Girls/";
const studioSiteUrl = process.env.REACT_APP_STUDIO_SITE_URL || "http://localhost:3000";

export default function GameSite() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <section
          className="game-hero"
          style={{ backgroundImage: `linear-gradient(90deg, rgba(7,9,13,.9), rgba(7,9,13,.34)), url(${accHero})` }}
        >
          <div className="game-copy">
            <p className="eyebrow">Visual Novel / Hallinan Classics</p>
            <h1>A Christmas Carol: But with Anime Girls</h1>
            <p>
              Read the Charles Dickens classic with a playful anime twist, cinematic CGs, atmospheric sound, and a cast reimagined for maximum holiday chaos.
            </p>
            <div className="hero-actions">
              <a className="button primary" href={steamUrl} rel="noreferrer" target="_blank">
                Steam page
              </a>
              <a className="button secondary" href={studioSiteUrl}>
                Hallinan Labs Studio
              </a>
            </div>
          </div>
        </section>

        <section className="section game-feature">
          <div className="video-frame">
            <iframe
              src="https://www.youtube.com/embed/LOJhVfsXYNc?si=my80LK8wt5Ivpztf"
              title="A Christmas Carol: But with Anime Girls trailer"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </div>
          <div>
            <p className="eyebrow">Featured title</p>
            <h2>A classic story, considerably more anime.</h2>
            <p>
              Ever wanted to read A Christmas Carol, but struggled with the lack of anime girls? This visual novel adapts Dickens with affectionate absurdity and full holiday melodrama.
            </p>
            <ul>
              <li>A full cast of gender-swapped kawaii anime girls.</li>
              <li>Atmospheric music, SFX, and stylized Japanese interjections.</li>
              <li>Cinematic animations and 20+ dramatic CGs.</li>
              <li>Planned release: December 2025.</li>
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

function Header() {
  return (
    <header className="site-header">
      <a className="brand" href="#home">
        <img src={logo} alt="Hallinan Labs logo" />
        <span>Hallinan Labs</span>
      </a>

      <nav className="desktop-nav" aria-label="Primary navigation">
        <a className="active" href="#home">Game</a>
        <a href={steamUrl} rel="noreferrer" target="_blank">Steam</a>
        <a href={studioSiteUrl}>Studio</a>
      </nav>
    </header>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-brand">
        <img src={heroLogo} alt="Hallinan Labs" />
        <span>Hallinan Labs</span>
      </div>
      <nav aria-label="Footer navigation">
        <a href={steamUrl} rel="noreferrer" target="_blank">Steam</a>
        <a href={studioSiteUrl}>Studio</a>
      </nav>
      <p>© {new Date().getFullYear()} Hallinan Labs. All rights reserved.</p>
    </footer>
  );
}
